import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: 960,
        padding: '50px 0',
        [theme.breakpoints.down('sm')]: {
            padding: '130px 0',
        },
    },
}));

const Project = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Grid container spacing={3} className='game-section'>
                {props.children}
            </Grid>
        </div>
    );
};

export default Project;
